// extracted by mini-css-extract-plugin
module.exports = {"viewerContainer":"ViewerScreen-module__viewerContainer___1sgsx"};